// NO EDITAR A MANO
import {ITraduccionMapKeys} from "services-comun/modules/traduccion/map";

import type {CmpGdprSimple} from "./simple";
import type {CmpGdprSinLogo} from "./sin_logo";
import soportados, {type Langs} from "../../langs";

export type CmpGdprDataP1Param = "brand" | "num_vendors";
export type CmpGdprDataP2Param = "brand";
export type CmpGdprDataP3Param = "url_cookies" | "url_privacidad";
export type CmpGdprNVendorsParam = "num_vendors";
export type CmpGdprQueryNVendorsParam = "n";

export type CmpGdprDataP1Params = Record<CmpGdprDataP1Param, string>;
export type CmpGdprDataP2Params = Record<CmpGdprDataP2Param, string>;
export type CmpGdprDataP3Params = Record<CmpGdprDataP3Param, string>;
export type CmpGdprNVendorsParams = Record<CmpGdprNVendorsParam, string>;
export type CmpGdprQueryNVendorsParams = Record<CmpGdprQueryNVendorsParam, string>;

export interface CmpGdprDataP1Record extends ITraduccionMapKeys {
    "socios"?: string;
    "no_socios"?: string;
}
export type CmpGdprDataP1Keys = keyof CmpGdprDataP1Record;

export interface CmpGdprDataP3Record extends ITraduccionMapKeys {
    "app"?: string;
    "web"?: string;
}
export type CmpGdprDataP3Keys = keyof CmpGdprDataP3Record;

export interface CmpGdpr {
    accept: string;
    accept_and_continue: string;
    accept_free: string;
    configurar: string;
    configure: string;
    data_p1: (key: CmpGdprDataP1Keys, params?: Partial<CmpGdprDataP1Params>)=>string;
    data_p2: (params?: Partial<CmpGdprDataP2Params>)=>string;
    data_p3: (key: CmpGdprDataP3Keys, params?: Partial<CmpGdprDataP3Params>)=>string;
    n_vendors: (params?: Partial<CmpGdprNVendorsParams>)=>string;
    query_n_vendors: (params?: Partial<CmpGdprQueryNVendorsParams>)=>string;
    query_vendors: string;
    reject: string;
    reject_all: string;
    reject_and_pay: string;
    reject_and_subscribe: string;
    simple: CmpGdprSimple;
    sin_logo: CmpGdprSinLogo;
    title: string;
}

const loader = async function(lang: Langs, defecto?: string): Promise<CmpGdpr> {
    let langToImport = soportados.indexOf(lang)<0 ? (defecto||'en') : lang;

    return import(/* webpackChunkName: "i18n/[request]/cmp.gdpr" */ `../../.src/${langToImport.replace("-", "")}/cmp/gdpr`).then(module=> module.default);
}

export default loader;
